const TAKE_5_DAILY = '/take-5-daily';
const FAQS = '/faqs';

export const URL_CONFIG = {
  GLOBAL_SEARCH: '/search?q',
  API_PAGINATION_COUNT: 'pagination/count',
  TAKE_5_DAILY,
  TAKE_5_DAILY_SEARCH: `${TAKE_5_DAILY}?search`,
  TAKE_FIVE_PODCAST: `${TAKE_5_DAILY}/podcast`,
  TAKE_FIVE_PODCASTS: `${TAKE_5_DAILY}/podcasts`,
  TAKE_FIVE_ARTICLES: `${TAKE_5_DAILY}/articles`,
  TAKE_FIVE_ARTICLE: `${TAKE_5_DAILY}/article`,
  TAKE_FIVE_VIDEOS: `${TAKE_5_DAILY}/videos`,
  TAKE_FIVE_VIDEO: `${TAKE_5_DAILY}/video`,
  TAKE_FIVE: `${TAKE_5_DAILY}`,
  
  WHO_WE_ARE: '/who-we-are',
  NEWS_ROOM: '/company/press',
  NEWS_ROOM_DETAIL: '/press-releases',
  CLINICAL_RESEARCH : '/company/clinical-research',
  STRATEGIC_COLLABORATIONS : '/company/strategic-collaborations',
  COMPANY_LEADERSHIP : '/company/leadership',
  COMPANY_PRESS: '/company/press',
  COMPANY_AWARDS : '/company/awards',
  FAVORITE:"/account/favorite",
  UNFAVORITE:"/account/unfavorite",
  FAVORITES:"/account/favorites",
  CUSTOMER:"/account/data/customer",

  FAQ:"/faq",
  FAQ_SEARCH:`${FAQS}/search`,
  FAQS: FAQS,
  CONTACTS: '/contacts',
  FAQS_SHIPPING: `${FAQS}/shipping`,
  FAQS_RETURNS_AND_EXCHANGES: `${FAQS}/returns-and-exchanges`,
  FAQS_SUPPLEMENTS: `${FAQS}/supplements`,
  FAQS_TESTS: `${FAQS}/tests`,
  FAQS_ACCOUNTS_SUBSCRIPTIONS: `${FAQS}/account-and-subscriptions`,
  FAQS_OTHER_QUESTIONS: `${FAQS}/other-questions`,
  FAQS_REWARDS: `${FAQS}/rewards`,
  FAQS_AMBASSADORS: `${FAQS}/ambassadors`,
  FAQS_REFERRALS: `${FAQS}/referrals`,
  BUILDER_API_URL: 'https://builder.io/api/v1/write',
  
  PRODUCT_BASE_URL: '/products',
  
  INTERNAL_BUILDER_WRITE_API: '/service/builder/update',
  MULTI_MEDIA_YOUTUBE_LINK: 'https://www.youtube.com/channel/UCaDgqa4VU8TECqIPq6C3LtA',
  MULTI_MEDIA_PODCAST_URL: 'https://open.spotify.com/show/2IYi1DtMn0vfwZ0L9mKLyi',
  CART: "/cart",
  CHECKOUT: "/checkout",
  QUICK_ORDER: "/quick-order",
  INGREDIENTS: "/ingredients",
  SET_BUNDLES: "set/bundles",
  PRODUCT_API_URL : '/.nuxt_bridge/products/dp',
  PRODUCT_SKU_LOOKUP_API_URL: '/.nuxt_bridge/products/sku',
  PRODUCT_LIST_API_URL : '/.nuxt_bridge/products',
  BENEFITS: 'Health Needs_',
  YOTPO_URL:'https://cdn-widgetsrepository.yotpo.com/v1/loader',
  AGENTIC_INIT : '/products/agentic',
  AGENTIC_FILTER_INIT_ENDPOINT: '/product/filter/init',
  AGENTIC_FILTER_QUERY_ENDPOINT: '/product/filter/query',
  AGENTIC_FILTER_COMPARE_ENDPOINT: '/product/filter/compare'
};
